import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';
import localeService from '@/services/localeService';

Vue.use(VueI18n);

function loadLocaleMessages(translator: VueI18n) {
  const messages: LocaleMessages = {};
  localeService.assignLocaleFiles(messages);
  localeService.assignServerMessages(messages).then(() => {
    const actualMessages = translator.messages;
    for (const locale of Object.keys(messages)) {
      const mergedMessages = actualMessages[locale]
        ? Object.assign(actualMessages[locale], messages[locale])
        : messages[locale];
      translator.mergeLocaleMessage(locale, mergedMessages);
    }
  });
}

const translator = new VueI18n({
  locale: localStorage.getItem('lang') || process.env.VITE_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VITE_I18N_FALLBACK_LOCALE || 'en'
  // silentTranslationWarn: process.env.NODE_ENV === 'development'
  // silentTranslationWarn: process.env.NODE_ENV === 'production' to avoid warnings dealing with i18n
});

loadLocaleMessages(translator);

export default translator;
